<template>
  <div class="kids-register-modal">
    <div class="kids-register-modal__inner">
      <h6 class="kids-register-modal__title">
        зарегистрируйтесь для&nbsp;участия в олимпиаде
      </h6>

      <p class="kids-register-modal__description">
        все подробности пришлем на почту
      </p>

      <div class="kids-register-modal__fields">
        <form-name-field
          ref="nameField"
          v-model="parentName"
          class="form__input"
          round-border
          placeholder="как вас зовут?"
        />

        <!--<p>-->
        <!--  возрастная группа-->
        <!--  {{ classNumberItems }}-->
        <!--</p>-->

        <form-select-field
          :value="ageGroup"
          :items="ageGroupItems"
          placeholder="возрастная группа"
          :error="ageGroupError"
          @update="ageGroup = $event"
        />

        <form-phone-field
          ref="phoneField"
          class="form__input form__input_phone"
          round-border
          placeholder="ваш номер телефона"
          :errors-list="submitError"
          @updatePhone="parentPhone = $event"
        />

        <form-email-field
          ref="emailField"
          v-model="email"
          class="form__input"
          round-border
          :submit-error="submitError"
          placeholder="ваша почта"
          @clearSubmitError="clearSubmitError"
        />
      </div>

      <!-- eslint-disable -->
      <p class="kids-register-modal__law">
        нажимая на кнопку, вы соглашаетесь
        с&nbsp;<nuxt-link
        to="/privacy"
        target="_blank"
      >условиями обработки данных</nuxt-link>
        в&nbsp;соответствии
        с&nbsp;<nuxt-link
        to="/privacy"
        target="_blank"
      >политикой конфиденциальности</nuxt-link>
      </p>
      <!-- eslint-enable -->

      <button
        class="m-btn kids-register-modal__btn"
        @click="register"
      >
        зарегистрироваться
      </button>
    </div>

    <button
      class="m-btn kids-register-modal__close"
      @click="closeModal"
    >
      <img
        src="/v2/header/modal-close.svg"
        alt="close"
      >
    </button>

    <div
      class="kids-register-modal__overlay"
      @click="closeModal"
    />
  </div>
</template>

<script>
import FormNameField from '@/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '@/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';
import FormSelectField from '@/components/v2/common/fileds/FormSelectField.vue';

export default {
  name: 'OlympiadKidsRegister',
  components: {
    FormSelectField,
    FormNameField,
    FormEmailField,
    FormPhoneField,
  },
  props: {
    material: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    parentName: '',
    ageGroup: '',
    parentPhone: '',
    email: '',
    submitError: [],
    olympiad: {},
  }),
  computed: {
    ageGroupItems() {
      if (!this.material?.olympiadPack?.olympiads) return [];

      return this.material.olympiadPack.olympiads.map((olympiad) => ({
        ...olympiad,
        title: olympiad.tAgeGroup,
        value: olympiad.ageGroup,
      }));
    },
    ageGroupError() {
      const haveError = this.submitError.some((e) => e.objectField === 'ageGroup');
      return haveError ? 'Ошибка!' : null;
    },
  },
  mounted() {
    this.ageGroup = this.material.olympiad?.ageGroup;
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    clearSubmitError(field) {
      this.submitError = this.submitError.filter((e) => e.objectField !== field);
    },

    validate() {
      let valid = true;

      if (this.$refs.nameField) {
        if (!this.$refs.nameField.validate()) valid = false;
      }

      if (this.$refs.phoneField) {
        if (!this.$refs.phoneField.validate()) valid = false;
      }

      if (this.$refs.emailField) {
        if (!this.$refs.emailField.validate()) valid = false;
      }

      return valid;
    },
    async register() {
      if (!this.validate()) return;

      const response = await this.$kidsApi.registerForOlympiad({
        ageGroup: this.ageGroup,
        childName: 'ребёнок',
        email: this.email,
        landerCode: this.material.olympiadPack?.landerCode,
        name: this.parentName,
        phone: this.parentPhone,
      });

      if (response.success || response.existingRegistration) {
        this.$router.push('/articles/ThankYou');
      } else {
        this.submitError = response.errors;
      }
    },
  },
};
</script>

<style scoped lang="scss">

.kids-register-modal {
  position: fixed;
  z-index: 99;
  inset: 0;
  display: grid;
  place-content: center;

  * {
    font-family: "Onest", sans-serif;
  }

  &__inner {
    position: relative;
    z-index: 2;
    width: calc(var(--scale) * 720);
    max-height: 98vh;
    overflow: auto;
    padding: calc(var(--scale) * 32) calc(var(--scale) * 40) calc(var(--scale) * 40);
    background-color: #FFFFFF;
    border-radius: calc(var(--scale) * 60);

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 366);
      padding: calc(var(--scale) * 20) calc(var(--scale) * 8) calc(var(--scale) * 8);
      border-radius: calc(var(--scale) * 32);
    }
  }

  &__title {
    position: relative;

    z-index: 2;
    font-weight: 500;
    font-size: calc(var(--scale) * 48);
    line-height: 110%;
    letter-spacing: -0.02em;
    color: #02120F;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 28);
      line-height: 95%;
      padding-inline: calc(var(--scale) * 8);
    }
  }

  &__description {
    margin-top: calc(var(--scale) * 12);

    font-weight: 400;
    font-size: calc(var(--scale) * 20);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      margin-top: calc(var(--scale) * 8);
      font-size: calc(var(--scale) * 16);
      padding-inline: calc(var(--scale) * 8);
    }
  }

  &__fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: calc(var(--scale) * 8);
    margin-block: calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      padding-inline: calc(var(--scale) * 8);
    }

    ::v-deep .select_wrapper {
      background-color: #FFFFFF;
      border: 1px solid rgba(167, 171, 172, 0.5);
      height: calc(var(--scale) * 80);
      border-radius: 100px;
      padding-block: 0;
      color: #A7ABAC;

      .select_result {
        font-size: calc(var(--scale) * 26) !important;
        color: $black-color !important;
      }

      .select_inner {
        height: 100%;
      }

      .select_dropdown {
        padding: calc(var(--scale) * 12) calc(var(--scale) * 8);
        border: 1px solid rgba(167, 171, 172, 0.5);
        border-radius: calc(var(--scale) * 32);
      }

      div.select_item {
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: #A7ABAC;
        transition: 200ms;

        &:hover {
          background-color: #E0E1E5;
          border-radius: 200px;
        }
      }
    }

    .form__input {
      ::v-deep input:not(.phone-field__input) {
        width: 100%;
        height: calc(var(--scale) * 80);
        background-color: #FFFFFF;
        border: 1px solid rgba(167, 171, 172, 0.5);

        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: $black-color;

        @include media-down($size-tablet) {
          height: calc(var(--scale) * 68);
          font-size: calc(var(--scale) * 18);
        }

        &::placeholder {
          color: #A7ABAC;
        }
      }

      ::v-deep .phone-field__input {
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: $black-color;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 18);
        }

        &::placeholder {
          color: #A7ABAC;
        }
      }

      ::v-deep .phone-field__wrap {
        height: calc(var(--scale) * 80);
        background-color: #FFFFFF;
        border: 1px solid rgba(167, 171, 172, 0.5);

        @include media-down($size-tablet) {
          height: calc(var(--scale) * 68);
        }

        input {
          border-radius: inherit;

          &::placeholder {
            color: #A7ABAC;
          }
        }

        &--error {
          border-color: #ff0040;
        }
      }
    }
  }

  &__law {
    margin-bottom: calc(var(--scale) * 40);

    font-weight: 400;
    font-size: calc(var(--scale) * 20);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 14);
    }

    a {
      text-decoration: underline;
      color: #FF9C12;

      @media (hover: hover) {
        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  &__btn {
    width: 100%;
    padding: calc(var(--scale) * 36) calc(var(--scale) * 10);
    border-radius: calc(var(--scale) * 24);
    transition: 200ms;
    background-color: #FF5319;

    font-weight: 500;
    font-size: calc(var(--scale) * 32);
    line-height: 110%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 30) 0;
      font-size: calc(var(--scale) * 18);
    }

    @media (hover: hover) {
      &:hover {
        background-color: #FF9C12;
      }
    }
  }

  &__close {
    position: absolute;
    z-index: 2;
    right: calc(var(--scale) * 40);
    top: calc(var(--scale) * 30);
    width: calc(var(--scale) * 44);

    @include media-down($size-tablet) {
      right: calc(var(--scale) * 20);
      top: calc(var(--scale) * 15);
    }
  }

  &__overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(#02120F, 0.3);
    backdrop-filter: blur(5px);
    cursor: pointer;
  }
}

</style>
